import { Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { Task_$reflection, Track_$reflection, Event$_$reflection } from "./Shared/SharedModels.jsx";
import { union_type, record_type, bool_type, option_type, array_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { tap, PromiseBuilder__TryFinally_7D49A2FD, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.24.0/Async.js";
import { toastServerError, Task, Track, Event$ } from "./ApiClient.jsx";
import { Result_ToOption } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { errorToast } from "./Toasts.jsx";
import { createElement } from "react";
import React from "react";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { defaultOf as defaultOf_1, int32ToString, createObj, safeHash, equals } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { map, equalsWith, tryFind, sumBy, contains, collect } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { Caption1Strong, Subtitle1, CardHeader, SkeletonItem, Skeleton, Title3, Badge, Label, Button, Link, Caption1, ProgressBar, Subtitle2, tokens, Card } from "@fluentui/react-components";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { MailInboxRegular, AlertRegular, WeatherSunnyLowRegular, PeopleCommunityRegular, ClockRegular, CalendarClockRegular, PersonAccountsRegular, LayerDiagonalPersonRegular, BookOpenRegular, LayerRegular, ArrowRightRegular } from "@fluentui/react-icons";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { bind } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { nb } from "date-fns/locale";
import { format as format_2 } from "date-fns";
import { useCtx } from "./Context.jsx";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { dataFetchFailedView } from "./Helpers.jsx";

class Model extends Record {
    constructor(UpcomingUserEvents, IsFetching, UserTracks, UserCompletedTasks) {
        super();
        this.UpcomingUserEvents = UpcomingUserEvents;
        this.IsFetching = IsFetching;
        this.UserTracks = UserTracks;
        this.UserCompletedTasks = UserCompletedTasks;
    }
}

function Model_$reflection() {
    return record_type("Home.Model", [], Model, () => [["UpcomingUserEvents", option_type(array_type(Event$_$reflection()))], ["IsFetching", bool_type], ["UserTracks", option_type(array_type(Track_$reflection()))], ["UserCompletedTasks", array_type(Task_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateEvents", "SetIsFetching", "UpdateUserTracks", "UpdateUserCompletedTasks"];
    }
}

function Msg_$reflection() {
    return union_type("Home.Msg", [], Msg, () => [[["Item", option_type(array_type(Event$_$reflection()))]], [["Item", bool_type]], [["Item", option_type(array_type(Track_$reflection()))]], [["Item", array_type(Task_$reflection())]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.UpcomingUserEvents, msg.fields[0], model.UserTracks, model.UserCompletedTasks);
        case 2:
            return new Model(model.UpcomingUserEvents, model.IsFetching, msg.fields[0], model.UserCompletedTasks);
        case 3:
            return new Model(model.UpcomingUserEvents, model.IsFetching, model.UserTracks, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.IsFetching, model.UserTracks, model.UserCompletedTasks);
    }
}

function init() {
    return new Model(undefined, true, undefined, []);
}

function Promises_fetchTracksAndEvents(dispatch) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => PromiseBuilder__TryFinally_7D49A2FD(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((Promise.all([startAsPromise(Event$.GetMy()), startAsPromise(Track.GetMy())])).then((_arg) => {
        dispatch(new Msg(0, [Result_ToOption(_arg[0])]));
        dispatch(new Msg(2, [Result_ToOption(_arg[1])]));
        return Promise.resolve();
    }))), () => {
        dispatch(new Msg(1, [false]));
    })));
    void pr;
}

function Promises_fetchUserCompletedTasks(dispatch, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, "getMyTasksError", "Noe gikk galt", "Kunne ikke hente dine gjennomførte oppgaver", undefined);
        }
        else {
            dispatch(new Msg(3, [res.fields[0]]));
        }
    }, startAsPromise(Task.GetMy()));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function TrackCard(trackCardInputProps) {
    let elems_9, elems_5, elems_2, elems, el, elems_1, el_2, el_4, elems_4, el_10, elems_3, el_8, el_6, elems_8, elems_6, el_12, el_14, elems_7, el_16, el_18;
    const track = trackCardInputProps.track;
    const model = trackCardInputProps.model;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    let fractionCompleted;
    const allTasksInTrack = collect((_arg) => _arg.RequiredTasks, track.TrackLevels);
    const totalCompleted = allTasksInTrack.filter((t) => contains(t, model.UserCompletedTasks, {
        Equals: equals,
        GetHashCode: safeHash,
    }));
    fractionCompleted = (totalCompleted.length / allTasksInTrack.length);
    const el_20 = Card;
    return createElement(el_20, createObj(ofArray([["appearance", "subtle"], ["style", {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1,
        borderRadius: 0,
        padding: 15,
        minHeight: 120,
    }], (elems_9 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        gap: 20 + "px ",
    }], (elems_5 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 10 + "px ",
        flexDirection: "column",
        flexGrow: 1,
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        gap: 15 + "px ",
        alignItems: "center",
    }], (elems = [(el = Subtitle2, createElement(el, {
        children: track.Name,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_1 = [(el_2 = ProgressBar, createElement(el_2, {
        thickness: "large",
        shape: "rounded",
        color: "brand",
        value: fractionCompleted,
    })), (el_4 = Caption1, createElement(el_4, {
        children: `${~~(fractionCompleted * 100)} % fullført`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => append(singleton(["justifyContent", "center"]), delay(() => append(isMobile ? singleton(["paddingTop", 15]) : empty(), delay(() => singleton(["minHeight", 100 + "%"]))))))))))))], (elems_4 = [(el_10 = Link, createElement(el_10, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["kurslop", int32ToString(track.Id)]), 1)], (elems_3 = [(el_8 = Button, createElement(el_8, {
        appearance: "primary",
        style: {
            width: 100 + "%",
        },
        icon: (el_6 = ArrowRightRegular, createElement(el_6, {})),
        iconPosition: "after",
        children: "Åpne",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 15 + "px ",
        flexWrap: "wrap",
    }], (elems_8 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_6 = [(el_12 = LayerRegular, createElement(el_12, {
        fontSize: 20,
        primaryFill: tokens.colorBrandBackground,
    })), (el_14 = Label, createElement(el_14, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${track.TrackLevels.length} nivåer`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_7 = [(el_16 = BookOpenRegular, createElement(el_16, {
        fontSize: 20,
        primaryFill: tokens.colorBrandBackground,
    })), (el_18 = Label, createElement(el_18, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${sumBy((_arg_1) => _arg_1.TrackLevelCourses.length, track.TrackLevels, {
            GetZero: () => 0,
            Add: (x_1, y_1) => (x_1 + y_1),
        })} kurs`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])])));
}

function EventCard(eventCardInputProps) {
    let elems_11, elems_6, elems_3, elems_1, elems_2, el_8, elems_5, el_14, elems_4, el_12, el_10, elems_10, elems_7, el_16, el_18, elems_8, el_20, el_22, locale, formatOptions, elems_9, el_24, el_26, locale_1, formatOptions_1;
    const event = eventCardInputProps.event;
    const model = eventCardInputProps.model;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const track_1 = bind((tracks) => tryFind((track) => track.TrackLevels.some((level) => level.TrackLevelCourses.some((tlc) => (tlc.Course.Id === event.Course.Id))), tracks), model.UserTracks);
    const el_28 = Card;
    return createElement(el_28, createObj(ofArray([["appearance", "subtle"], ["style", {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1,
        borderRadius: 0,
        padding: 15,
        minHeight: 120,
    }], (elems_11 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
    }], (elems_6 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 5 + "px ",
        flexDirection: "column",
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 15 + "px ",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => {
        let el;
        return append(singleton((el = Badge, createElement(el, {
            size: "small",
            children: event.Course.Name,
        }))), delay(() => {
            let el_6, elems, el_4, el_2;
            const matchValue = track_1;
            if (matchValue != null) {
                const track$0027 = matchValue;
                return singleton((el_6 = Link, createElement(el_6, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["kurslop", int32ToString(track$0027.Id)]), 1)], ["style", {
                    textDecorationLine: "none",
                }], (elems = [(el_4 = Button, createElement(el_4, {
                    appearance: "subtle",
                    size: "small",
                    style: {
                        paddingLeft: 0,
                        display: "flex",
                        alignItems: "center",
                        gap: 5 + "px ",
                    },
                    icon: (el_2 = LayerDiagonalPersonRegular, createElement(el_2, {
                        fontSize: 20,
                        primaryFill: tokens.colorBrandBackground,
                    })),
                    children: track$0027.Name,
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))));
            }
            else {
                return singleton(defaultOf());
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        gap: 15 + "px ",
        alignItems: "center",
    }], (elems_2 = [(el_8 = Subtitle2, createElement(el_8, {
        children: event.Name,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => append(singleton(["justifyContent", "center"]), delay(() => append(isMobile ? singleton(["paddingTop", 15]) : empty(), delay(() => singleton(["minHeight", 100 + "%"]))))))))))))], (elems_5 = [(el_14 = Link, createElement(el_14, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["kurs", int32ToString(event.Id)]), 1)], (elems_4 = [(el_12 = Button, createElement(el_12, {
        appearance: "primary",
        style: {
            width: 100 + "%",
        },
        icon: (el_10 = ArrowRightRegular, createElement(el_10, {})),
        iconPosition: "after",
        children: "Åpne",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 15 + "px ",
        flexWrap: "wrap",
    }], (elems_10 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_7 = [(el_16 = PersonAccountsRegular, createElement(el_16, {
        fontSize: 20,
        primaryFill: tokens.colorBrandBackground,
    })), (el_18 = Label, createElement(el_18, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${event.Teacher.FirstName} ${event.Teacher.LastName}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_8 = [(el_20 = CalendarClockRegular, createElement(el_20, {
        fontSize: 20,
        primaryFill: tokens.colorBrandBackground,
    })), (el_22 = Label, createElement(el_22, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${(locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_2(event.Time, "dd MMM yy", formatOptions))))}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_9 = [(el_24 = ClockRegular, createElement(el_24, {
        fontSize: 20,
        primaryFill: tokens.colorBrandBackground,
    })), (el_26 = Label, createElement(el_26, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${(locale_1 = nb, (formatOptions_1 = {}, (formatOptions_1.locale = locale_1, format_2(event.Time, "HH:mm", formatOptions_1))))}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_11))])])));
}

export function View() {
    let elems_17;
    const patternInput = useCtx();
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    useEffectOnce(() => {
        Promises_fetchTracksAndEvents(dispatch);
        Promises_fetchUserCompletedTasks(dispatch, patternInput[1]);
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 2 + "rem",
    }], (elems_17 = toList(delay(() => {
        let elems_1, elems, el, el_2;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = [(el = Title3, createElement(el, {
            children: "Hjemmeside",
        })), (el_2 = Caption1, createElement(el_2, {
            children: "Oversikt og status for kursløp og kommende kurs",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", {})], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let el_10, elems_3, elems_2, el_4, el_6, el_8, elems_16, elems_12, el_30, elems_7, el_22, el_12, el_14, el_16, el_20, elems_4, el_18, elems_6, el_48, elems_11, el_42, el_32, el_34, el_36, el_40, elems_8, el_38, elems_10, el_62, elems_15, el_56, el_50, el_52, el_54, elems_14, elems_13, el_58, el_60;
            return model_1.IsFetching ? singleton((el_10 = Skeleton, createElement(el_10, createObj(ofArray([["style", {
                display: "flex",
                flexWrap: "wrap",
                gap: 2 + "rem",
            }], (elems_3 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => append(singleton(["gap", 2 + "rem"]), delay(() => append(isMobile ? singleton(["minWidth", 100 + "%"]) : singleton(["width", 45 + "%"]), delay(() => singleton(["flexGrow", 2]))))))))))))], (elems_2 = [(el_4 = SkeletonItem, createElement(el_4, {
                style: {
                    height: 20 + "vh",
                },
                animation: "wave",
                shape: "rectangle",
            })), (el_6 = SkeletonItem, createElement(el_6, {
                style: {
                    height: 35 + "vh",
                },
                animation: "wave",
                shape: "rectangle",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), (el_8 = SkeletonItem, createElement(el_8, {
                style: createObj(toList(delay(() => append(singleton(["flexGrow", 1]), delay(() => append(singleton(["height", 57.4 + "vh"]), delay(() => (isMobile ? singleton(["minWidth", 100 + "%"]) : singleton(["width", 35 + "%"]))))))))),
                animation: "wave",
                shape: "rectangle",
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))) : singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexWrap: "wrap",
                gap: 2 + "rem",
            }], (elems_16 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 2 + "rem",
                minWidth: 50 + "%",
                flexGrow: 2,
            }], (elems_12 = [(el_30 = Card, createElement(el_30, createObj(ofArray([["style", {
                padding: 0,
                gap: 0 + "px ",
            }], (elems_7 = [(el_22 = CardHeader, createElement(el_22, {
                image: (el_12 = LayerDiagonalPersonRegular, createElement(el_12, {
                    fontSize: 32,
                    primaryFill: tokens.colorBrandForeground1,
                })),
                style: {
                    padding: 15,
                    borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1,
                },
                header: (el_14 = Subtitle1, createElement(el_14, {
                    children: "Dine kursløp",
                })),
                description: (el_16 = Caption1, createElement(el_16, {
                    children: "Oversikt og status på kursløp du er påmeldt",
                })),
                action: (el_20 = Button, createElement(el_20, createObj(ofArray([["as", "a"], ["size", "small"], ["href", RouterModule_encodeParts(singleton_1("kurslop"), 1)], (elems_4 = [(el_18 = Caption1Strong, createElement(el_18, {
                    wrap: false,
                    children: "Alle kursløp",
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])))),
            })), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => (!isMobile ? append(singleton(["overflow", "scroll"]), delay(() => singleton(["scrollbarWidth", "none"]))) : empty()))))))))], (elems_6 = toList(delay(() => {
                let testExpr, elems_5, el_24, el_26, el_28, tracks;
                const matchValue = model_1.UserTracks;
                return (matchValue != null) ? (((testExpr = matchValue, !equalsWith(equals, testExpr, defaultOf_1()) && (testExpr.length === 0))) ? singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 5 + "px ",
                    padding: 15,
                }], (elems_5 = [(el_24 = PeopleCommunityRegular, createElement(el_24, {
                    primaryFill: tokens.colorBrandForeground1,
                    style: {
                        fontSize: 82 + "px",
                    },
                })), (el_26 = Caption1, createElement(el_26, {
                    children: "Du er ikke påmeldt noen kursløp",
                })), (el_28 = Button, createElement(el_28, {
                    as: "a",
                    href: RouterModule_encodeParts(singleton_1("kurslop"), 1),
                    size: "small",
                    children: "Se alle kursløp",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : ((tracks = matchValue, map((track) => createElement(TrackCard, {
                    model: model_1,
                    track: track,
                }), tracks)))) : singleton(dataFetchFailedView());
            })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])))), (el_48 = Card, createElement(el_48, createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["minHeight", 35 + "vh"]), delay(() => append(!isMobile ? singleton(["maxHeight", 45 + "vh"]) : empty(), delay(() => append(singleton(["padding", 0]), delay(() => singleton(["gap", 0 + "px "]))))))))))], (elems_11 = [(el_42 = CardHeader, createElement(el_42, {
                style: {
                    padding: 15,
                    borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1,
                },
                image: (el_32 = BookOpenRegular, createElement(el_32, {
                    fontSize: 32,
                    primaryFill: tokens.colorBrandForeground1,
                })),
                header: (el_34 = Subtitle1, createElement(el_34, {
                    children: "Dine kommende kurs",
                })),
                description: (el_36 = Caption1, createElement(el_36, {
                    children: "Kommende kurs du er påmeldt",
                })),
                action: (el_40 = Button, createElement(el_40, createObj(ofArray([["as", "a"], ["size", "small"], ["href", RouterModule_encodeParts(singleton_1("kurs"), 1)], ["iconPosition", "after"], (elems_8 = [(el_38 = Caption1Strong, createElement(el_38, {
                    wrap: false,
                    children: "Alle kurs",
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])])))),
            })), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => (!isMobile ? append(singleton(["overflow", "scroll"]), delay(() => singleton(["scrollbarWidth", "none"]))) : empty()))))))))], (elems_10 = toList(delay(() => {
                let testExpr_1, elems_9, el_44, el_46, upcomingUserEvents;
                const matchValue_1 = model_1.UpcomingUserEvents;
                return (matchValue_1 != null) ? (((testExpr_1 = matchValue_1, !equalsWith(equals, testExpr_1, defaultOf_1()) && (testExpr_1.length === 0))) ? singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }], (elems_9 = [(el_44 = WeatherSunnyLowRegular, createElement(el_44, {
                    primaryFill: tokens.colorBrandForeground1,
                    style: {
                        fontSize: 96 + "px",
                    },
                })), (el_46 = Caption1, createElement(el_46, {
                    children: "Kurs du melder deg på vil havne her",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : ((upcomingUserEvents = matchValue_1, map((event) => createElement(EventCard, {
                    model: model_1,
                    event: event,
                }), upcomingUserEvents)))) : singleton(dataFetchFailedView());
            })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_11))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))), (el_62 = Card, createElement(el_62, createObj(ofArray([["style", {
                flexGrow: 1,
                minWidth: 40 + "%",
                minHeight: 40 + "vh",
                maxHeight: 60 + "vh",
                padding: 0,
            }], (elems_15 = [(el_56 = CardHeader, createElement(el_56, {
                image: (el_50 = AlertRegular, createElement(el_50, {
                    fontSize: 32,
                    primaryFill: tokens.colorBrandForeground1,
                })),
                style: {
                    padding: 15,
                    borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1,
                },
                header: (el_52 = Subtitle1, createElement(el_52, {
                    children: "Varsler",
                })),
                action: (el_54 = Button, createElement(el_54, {
                    appearance: "transparent",
                    children: "Marker som lest",
                    disabled: true,
                })),
            })), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
            }], (elems_14 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }], (elems_13 = [(el_58 = MailInboxRegular, createElement(el_58, {
                primaryFill: tokens.colorBrandForeground1,
                style: {
                    fontSize: 82 + "px",
                },
            })), (el_60 = Caption1, createElement(el_60, {
                children: "Relevante varsler vil havne her",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_15))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_17))])])));
}

//# sourceMappingURL=Home.jsx.map
